<template>
    <div>
        <div class="printBtn">
            <v-btn fab @click="printPasses()" color="primary">
                <v-icon>mdi-printer</v-icon></v-btn>
        </div>
        <v-alert v-if="printPaesse.preparingPrint" text style="max-width: 400px" icon="mdi-information"
                 :class="[{'mx-auto': $vuetify.breakpoint.smAndUp},{'mx-5': $vuetify.breakpoint.xsOnly}, 'body-2 mt-5 ']">
            Bitte um etwas Geduld, die erforderlichen Daten werden geladen!
            <v-progress-linear indeterminate class="mt-2"/>
        </v-alert>
        <v-alert v-else text style="max-width: 400px" icon="mdi-information"
                 :class="[{'mx-auto': $vuetify.breakpoint.smAndUp},{'mx-5': $vuetify.breakpoint.xsOnly}, 'body-2 mt-5 ']">
            Auf eine Karte klicken um sie aus der Druckliste zu entfernen!</v-alert>
        <div class="text-center pt-1">
            <div id="printArea-spielerPaesse" class="d-inline-block">
                <paesse-drucken-karte v-for="(pass, i) in druckListe" :key="i"
                                      @clicked="requestConfirmationForRemoval"
                                      class="html2pdf__page-break mb-3" :pass="pass"/>
            </div>
        </div>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmCardDelete">
        </confirm-dialog>
    </div>
</template>

<script>
import PaesseDruckenKarte from "@/views/paesse/drucken/paesseDruckenKarte";
import html2pdf from "html2pdf.js/src";
import ConfirmDialog from "@/components/elements/confirmDialog";
import TimeStamp from "@/services/timeStamp";
export default {
    name: "paesse-drucken-vorschau-inhalt",
    components: {ConfirmDialog, PaesseDruckenKarte},
    computed: {
        printPaesse(){ return this.$store.state.local.printPaesse },
        druckListe(){ return this.printPaesse?.druckListe}
    },
    data: () => ({
        confirmDelete: {
            open: false,
            question: '',
            item: null,
        },
    }),
    methods: {
        requestConfirmationForRemoval(pass){
            this.confirmDelete.item = pass;
            this.confirmDelete.header = pass.vorname + ' ' + pass.nachname;
            this.confirmDelete.question = 'Möchtest du diesen Pass (' + pass.flagBottomRow + ') wirklich aus der Druckliste löschen?';
            this.confirmDelete.open = true;
        },
        processConfirm(reply) {
            if ( reply ) {
                this.removeCard(this.confirmDelete.item);
            }
            this.confirmDelete.open = false;
        },
        async printPasses(){
            const element = document.getElementById("printArea-spielerPaesse")
            const opt = { margin: 0,
                filename: 'Spielerpässe_' + TimeStamp.getTodayString() + '.pdf',
                jsPDF: { format: 'credit-card', orientation: 'landscape' },
                html2canvas:  { dpi: 300, scale: 4, letterRendering: true, },
            }
            html2pdf().set(opt).from(element).save();
            html2pdf().set(opt).from(element).toPdf().get('pdf').then((pdf) => {
                window.open(pdf.output('bloburl'), '_blank');
            });
            await this.printPaesse.processPrint()
        },
        removeCard(pass){
            this.printPaesse.removeCardFromDruckListe(pass)
        }
    },
}
</script>

<style scoped>
    .printBtn{position: absolute; top: 64px; right: 16px; z-index: 5}
</style>